import * as groupService from "../../../../services/groups";
import * as settings from "../../../../services/settings";

import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Space,
  Spin,
  Transfer,
  Typography,
  notification,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ArrowLeftOutlined } from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { useTranslation } from "react-i18next";

// Extend dayjs with plugins
dayjs.extend(customParseFormat);

const TYPE_EDIT = "EDIT";
const TYPE_CREATE = "CREATE";
export const CreateRoleManagementPage = () => {
  const hasFetched = useRef(false);
  const [loading, setLoading] = useState(false);
  const [formUser] = Form.useForm();
  const { Title } = Typography;
  const { t } = useTranslation("group", "buttons");
  const { accessToken } = useAccessToken();
  const [stateType, setStateType] = useState(TYPE_CREATE);
  const [groupsData, setGroupsData] = useState(TYPE_CREATE);
  const [isSubmit, setIsSubmit] = useState(false);
  const navigation = useNavigate();
  const location = useLocation();
  const data = location.state;
  const [groupPermissionsData, setGroupPermissionsData] = useState([]);
  const [targetRolePermissionKeys, setTargetRolePermissionKeys] = useState([]);

  const fetchGroupPermissions = async (values) => {
    const tempPermissionTargetKeys = [];
    const tempPermissionData = [];
    const prepareGetPermission = {
      id: values ? values.id : null,
    };
    try {
      const response = await groupService.getGroupRolePermissions(accessToken, prepareGetPermission);
      response.permissionsAll.forEach((item) => {
        const data = {
          key: item.id,
          title: item.name,
          description: `${item.id}-${item.name}`,
        };
        tempPermissionData.push(data);
      });
      response.permissionsGroup.forEach((item) => {
        tempPermissionTargetKeys.push(item.id);
      });
      setGroupPermissionsData(tempPermissionData);
      setTargetRolePermissionKeys(tempPermissionTargetKeys);
      // ให้ Form ได้ค่าเดียวกับ Transfer — ไม่งั้น submit จะได้ user_permissions ไม่ตรงกับที่เลือก
      formUser.setFieldValue("user_permissions", tempPermissionTargetKeys);
    } catch (err) {
      console.error("[CreateRoleManagementPage] fetchGroupPermissions: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const onFinish = () => {
    setIsSubmit(true);
    if (stateType == TYPE_CREATE) {
      createRole();
    } else {
      updateRole();
    }
  };

  const createRole = async () => {
    await formUser.validateFields();
    const values = await formUser.getFieldsValue();
    setLoading(true);
    try {
      const response = await groupService.createGroupRolePermission(accessToken, {
        ...values,
        user_permissions: values.user_permissions ?? targetRolePermissionKeys,
      });
      if (response !== null || response != undefined) {
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Create User success"}</>);
        setTimeout(() => {
          navigation("/usermanagement/group");
        }, 2000);
        setLoading(false);
      }
    } catch (err) {
      console.error("[CreateRoleManagementPage] createRole: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const updateRole = async () => {
    await formUser.validateFields();
    const values = await formUser.getFieldsValue();
    let prepareUpdate = {
      id: data.value.id,
      name: values.name,
      // Transfer ถูกควบคุมด้วย targetKeys — ใช้ state ล่าสุดเป็นหลักเพื่อไม่ให้สิทธิ์หายตอน submit
      user_permissions: values.user_permissions ?? targetRolePermissionKeys,
    };
    setLoading(true);
    try {
      const response = await groupService.updateGroupRolePermission(accessToken, prepareUpdate);
      if (response !== null || response != undefined) {
        openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"Update User success"}</>);
        setTimeout(() => {
          navigation("/usermanagement/group");
        }, 2000);
        setLoading(false);
      }
    } catch (err) {
      console.error("[CreateRoleManagementPage] updateRole: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      setLoading(false);
    }
  };

  const items = [
    {
      title: <span>{t("Page_Body_Tab_Menu.Home", { ns: "menus" })}</span>,
    },
    {
      title: <span>{t("Page_Body_Tab_Menu.Menu", { ns: "menus" })}</span>,
    },
    {
      title: <a href="/usermanagement/group">{t("Title_Group")}</a>,
    },
    {
      title: (
        <a style={{ fontWeight: 600, color: "black" }}>
          {stateType == TYPE_EDIT ? `${t("Create_Group.Title_Edit_Group")}` : `${t("Create_Group.Title_Create_Group")}`}
        </a>
      ),
    },
  ];

  const setDetailData = async (data) => {
    formUser.setFieldValue("name", data.name);
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    setLoading(true);
    if (!accessToken) return;
    setLoading(false);
    setIsSubmit(false);
    fetchGroupPermissions(data.value);
    if (data.type == TYPE_EDIT) {
      setStateType(TYPE_EDIT);
      setGroupsData(data.value);
      setDetailData(data.value);
    }
  }, [accessToken, data]);

  // permission
  const filterOptionPermission = (inputValue, option) =>
    (option?.description ?? "").toLowerCase().includes(inputValue.toLowerCase());
  const handleChangePermission = (newTargetKeys) => {
    setTargetRolePermissionKeys(newTargetKeys);
    formUser.setFieldValue("user_permissions", newTargetKeys);
  };
  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Breadcrumb items={items}></Breadcrumb>
            <Row style={{ padding: "15px 0px 0px 0px" }}>
              <Col span={12}>
                <Title
                  level={4}
                  style={{
                    textWrap: "nowrap",
                    display: "flex",
                    gap: "7px",
                  }}
                >
                  <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  {stateType === TYPE_EDIT
                    ? `${t("Create_Group.Title_Edit_Group")}`
                    : `${t("Create_Group.Title_Create_Group")}`}
                </Title>
              </Col>
            </Row>
            <Divider />
            <Form
              form={formUser}
              labelCol={{
                span: 6,
              }}
              wrapperCol={{
                span: 18,
              }}
              style={{
                maxWidth: "50%",
                minWidth: 360,
                marginTop: "3%",
              }}
              onFinish={onFinish}
            >
              <Form.Item
                label={t("Create_Group.Name")}
                name="name"
                key="name"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Please input code!",
                  },
                ]}
              >
                <Input allowClear="true" placeholder={"name"} style={{ minWidth: 200 }} />
              </Form.Item>
              <Divider />
              <Row>
                <Col span={12}>
                  <Title
                    level={4}
                    style={{
                      textWrap: "nowrap",
                      display: "flex",
                      gap: "7px",
                    }}
                  >
                    {`${t("Create_Group.Permission.Title")}`}
                  </Title>
                </Col>
              </Row>
              <Form.Item label={t("Create_Group.Permission.Title")} name="user_permissions" key="user_permissions">
                <Transfer
                  listStyle={{
                    width: 500,
                    height: 500,
                  }}
                  dataSource={groupPermissionsData}
                  showSearch
                  filterOption={filterOptionPermission}
                  targetKeys={targetRolePermissionKeys}
                  onChange={handleChangePermission}
                  render={(item) => item.title}
                  // showSelectAll={false}
                />
              </Form.Item>
              <Divider />
              <Row align="middle" justify="end" style={{ marginTop: "20px" }}>
                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={loading}
                      loading={loading}
                    >
                      {t("BTN_Save", { ns: "buttons" })}
                    </Button>
                    <Button
                      htmlType="button"
                      onClick={() => {
                        navigation("/usermanagement/group");
                      }}
                    >
                      {t("BTN_Cancel", { ns: "buttons" })}
                    </Button>
                  </Space>
                </Form.Item>
              </Row>
            </Form>
          </Col>
        </Row>
      </Spin>
    </>
  );
};
